import { Phone, Mail } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="main-footer" className="bg-black text-zinc-300 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div className="flex items-center gap-2">
            <span className="bg-red-600 text-white font-display font-bold text-xl px-2 py-0.5 tracking-tight shadow-[0_0_20px_rgba(239,68,68,0.5)]">RM</span>
            <div>
              <p className="font-display font-medium uppercase tracking-tight text-white text-lg leading-none">
                {t.footer.brand}
              </p>
              <p className="text-xs uppercase tracking-wide text-zinc-300 mt-1">{t.footer.location}</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
            <a href="tel:+359892600604" className="flex items-center gap-2 hover:text-red-500 transition-colors">
              <Phone size={16} /> +359 892 600 604
            </a>
            <a href="mailto:megastream@abv.bg" className="flex items-center gap-2 hover:text-red-500 transition-colors">
              <Mail size={16} /> megastream@abv.bg
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-zinc-800 text-sm text-zinc-400">
          © {new Date().getFullYear()} RM {t.footer.brand} — {t.footer.city}. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};
